(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SignerProvider", [], factory);
	else if(typeof exports === 'object')
		exports["SignerProvider"] = factory();
	else
		root["SignerProvider"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition